//Cart Page Offer
var carto_modal = document.getElementById("cart-order-modal");
var carto_btn = document.getElementById("cart-order-btn");
var carto_span = document.querySelector(".cart-order-modal-close");

carto_btn.onclick = function(a) {
  a.preventDefault();
  carto_modal.classList.add("open");
}

carto_span.onclick = function() {
  carto_modal.classList.remove("open");
}

window.onclick = function(event) {
  if (event.target == carto_modal) {
    carto_modal.classList.remove("open");
  }
}